import { render, staticRenderFns } from "./ProductsTablee.vue?vue&type=template&id=5cc3e757&scoped=true"
import script from "./ProductsTablee.vue?vue&type=script&lang=js"
export * from "./ProductsTablee.vue?vue&type=script&lang=js"
import style0 from "./ProductsTablee.vue?vue&type=style&index=0&id=5cc3e757&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc3e757",
  null
  
)

export default component.exports